import { SlidersHorizontalIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

export const NoTypeSelected = observer(() => {
  return (
    <div className="mt-4 flex h-64 w-full items-center justify-center rounded-md border border-dashed border-gray-300 bg-gray-50 p-8 text-center shadow-sm">
      <div className="flex flex-col items-center space-y-2">
        <SlidersHorizontalIcon className="h-10 w-10 text-gray-400" />
        <p className="text-lg font-medium text-gray-700">
          No parameter selected
        </p>
        <p className="text-sm text-gray-500">
          Select a parameter to configure it
        </p>
      </div>
    </div>
  );
});
